import React, { useState, useEffect } from "react";
import axiosInstance from "../../../interceptor/axiosInstance";
import { toast } from "react-toastify";

const FacilityExtraForm = ({ id, onClose }) => {
  const [formData, setFormData] = useState({
    user: id,
    department: "",
    designation: "",
    title: "",
    gender: "",
    doj: "",
  });

  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    axiosInstance.get(`/programs/details/`)
      .then((response) => {
        const { designations, departments } = response.data?.data || {};
        setDesignations(designations || []);
        setDepartments(departments || []);
      })
      .catch((error) => {
        toast.error('Failed to fetch program details.');
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await axiosInstance.post("accounts/faculty/", { ...formData });
      toast.success("Faculty profile completed successfully!");
      onClose();
    } catch (error) {
      let errorMessage = "Failed to submit form";
      
      if (error.response && error.response.data) {
        const { message, errors } = error.response.data;
        if (message) errorMessage = message;

        if (errors) {
          const errorDetails = Object.entries(errors)
            .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
            .join("\n");
          errorMessage += `\n${errorDetails}`;
        }
      }

      toast.error(errorMessage);
    }
    setIsSubmitting(false);
  };

  return (
    <div className="user-profile-completion-wrapper">
      <div className="user-profile-completion-header">
        <h2>Complete Faculty Profile</h2>
        <span className="user-profile-completion-close" onClick={onClose}>
          ×
        </span>
      </div>

      <form onSubmit={handleSubmit} className="user-profile-completion-form">
        <div className="user-profile-completion-row">
          <div className="user-profile-completion-field">
            <label>Department *</label>
            <select
              name="department"
              value={formData.department}
              onChange={handleChange}
              required
            >
              <option value="">Select Department</option>
              {departments.map((dept) => (
                <option key={dept.id} value={dept.name}>
                  {dept.name}
                </option>
              ))}
            </select>
          </div>

          <div className="user-profile-completion-field">
            <label>Designation *</label>
            <select
              name="designation"
              value={formData.designation}
              onChange={handleChange}
              required
            >
              <option value="">Select Designation</option>
              {designations.map((desig) => (
                <option key={desig.id} value={desig.name}>
                  {desig.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="user-profile-completion-row">
          <div className="user-profile-completion-field">
            <label>Title (Optional)</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter title"
            />
          </div>

          <div className="user-profile-completion-field">
            <label>Gender</label>
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
            >
              <option value="">Select Gender</option>
              <option value="m">Male</option>
              <option value="f">Female</option>
            </select>
          </div>
        </div>

        <div className="user-profile-completion-row">
          <div className="user-profile-completion-field">
            <label>Date of Joining (Optional)</label>
            <input
              type="date"
              name="doj"
              value={formData.doj}
              onChange={handleChange}
              min={new Date().toISOString().split("T")[0]}
            />
          </div>
        </div>

        <div className="user-profile-completion-actions">
          <button
            type="submit"
            disabled={isSubmitting}
            className="user-profile-completion-submit"
          >
            {isSubmitting ? (
              <>
                <span className="user-profile-completion-spinner"></span>
                Completing...
              </>
            ) : (
              "Complete Profile"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default FacilityExtraForm;
